export const langEs = {
    ticketLgy: {
        AuditResult: 'Audit Result',
        ExcepQuestion: 'Abnormal Problems',
        ExcepAnswer: 'Exception Option',
        TicketsTotal: 'Tickets Total',
        Invalid: "Inválido",
        Effected: "efectuado",
        Unblock: "Desatascar",
        Status: "Estado",
        Normal: "Normal",
        invalid: "Inválido",
        Block: "bloquear",
        Success: "Éxito",
        Failed: "Fallido",
        TicketTag: "Etiqueta de entrada",
        PartialCompletionTime: "Tiempo de finalización parcial",
        GoogleVerification: "verificación de Google",
        Active: "activado",
        Di: "desactivado",
        Outsourcingornot: "Tipo de empleado",
        LocalCollection: "Colección local",
        Outsourcing: "Outsourcing",
        All: "Todas",
        PhoneVerify: "Validación manual",
        plschoose: "los pls eligen",
        plsinputID: "ID de entrada por favor",
        TotalRepayment: "Monto a pagar",
        UserRepaymentIntoAccount: "Monto pagado",
        UserRpaymentTime: "tiempo de pago del usuario",
        Rollover: "Pago de la extensión ",
        RolloverTime: "Tiempo de pago",
        CouponCredited: "Pago con el cupón de descuento",
        CouponCreditTime: "Tiempo de uso del cupón",
        DeductionCredited: "Monto de descuento",
        DeductionCreditedTime: "Tiempo de descontar",
        OtherEntry: "Otro pago",
        OtherEntryTime: "tiempo de otro pago",
        ButtonManagement: "Button management",
        ListManagement: "List management",
        Button: "Button",
        Authority: "Authority",
        Add: "Add",
        Edit: "Edit",
        Delete: "Delete",
        RouteList: "Route list",
        addaFirstLevelPage: "新增一级页面",
        Save: "保存",
        AddCallList: "Nueva lista de llamadas",
        ListOrderConfiguration: "Configuración de orden de lista",
        ListOrder: "Orden de la lista",
        ListList: "Lista de lista",
        AutoDial: "Marcación automática",
        Stop: "Detener la marcación automática",
        DialID: "Marcar ID",
        NextCallTime: "Hora de la próxima llamada",
        Approve: "Aprobada",
        Fail: "No aprobada",
        Invalidation: "Inválido",
        RejectAnApplication: "Rechazado",
        BasicInformation: "Datos básicos",
        OrderTag: "etiqueta de pedido",
        ManualReview: "Validación manual",
        ContactInformationAudit: "Validar los contactos",
        CustomerInformationAudit: "Validar los datos",
        PhoneReview: "Revisión de teléfono",
        AuditCompleted: "Validación completa",
        LaterProcessing: "Pendientes",
        Male: "masculino",
        Female: "mujer",
        Secrecy: "Mantener secreto",
        OutCall: "Llamada",
        SaveCallLog: "Guardar registro de llamadas",
        DialingMethod: "Método de marcación",
        InSystem: "En el sistema",
        OutsideSystem: "Fuera del sistema",
        QualityInspectionResults: "Resultados de la inspección de calidad",
        QualityInspectionNotes: "Notas de inspección de calidad",
        TelemarketingDistribution: "Asignación de Venta"
    },
    formLgy: {
        Supplier: "proveedor",
        ExtensionNumber: "número de extensión",
        Name: "nombre de empleo",
        RoleList: "lista de rol",
        TicketCategory: "tipo de caso",
        QueryDimension: "Dimensión de búsqueda",
        Date: "fecha",
        Coupon: "Cupón",
        ButtonSelection: "按钮选择",
        Routing: "路由选择",
        Aging: "Envejecimiento",
        QueueSorting: "Clasificación de la cola",
        ListCallOrder: "Listar orden de llamadas",
        TicketMaxWorkingNumberHistory: "Número máximo de casos asignados en la historia",
        EffectiveDate: "Fecha efectiva",
        TicketCrowdRoleGroup: "Orden multitud (grupo de roles)",
        TicketCrowdRoleGroup2: "Grupo de roles:",
        TotalTickets: "工单总量:",
        LeftTicket:'分配后剩余单量:',       
        orderTags: 'Etiqueta',
    },
    tableLgy: {
        AverageCallVolume: "Volumen promedio de llamadas",
        AverageConnectionAmount: "valor promedio",
        EmployeeRole: "Rol del empleado",
        Leader: "Líder",
        Groupleader: "Lider de grupo",
        ConnectedRate: "Porcentaje de conexión",
        CallMedian: "número de personas en llamada",
        RegistrationTime: "Registrar tiempo",
        LastLoginTime: "Última hora de inicio de sesión",
        PageName: "Page name",
        ButtonBame: "Button name",
        RouteName: "Route name",
        Route: "路由",
        Value: "Value",
        AutoCall: "Llamada automática",
        ManualCall: "llamada manual",
        CallMode: "Call Mode",
        RuleNumber: "Número de regla",
        RuleName: "Nombre de la regla",
        RuleDetails: "Detalles de la regla"
    },
    menuLgy: {
        ResultStatistics:'Estadístico de resultado de gestión',
        OverdueReasonStat:'Estadístico de motivo de atraso',
        CallRecordData: "Datos de registro de llamadas",
        CollectionPerformanceDetails: "Detalles del rendimiento de la colección",
        SelectCouponTemplate: "Seleccione una plantilla de cupón",
        PageManagement: "Page management",
        RouteManagement: "Route management",
        MenuList: "菜单列表",
        MenuDetails: "菜单详情",
        CallSequenceConfiguration: "secuencia de llamada",
        EmployeeReviewDetails: "Detalles de la revisión del empleado",
        CustomerInformation: "Información al cliente",
        Audit: "Revisar",
        DistributionRules: "Reglas de distribución"
    },
    tipsLgy: {
        EnterPageName: "Please enter the page name",
        EnterRouteName: "Please enter the route name",
        ConfirmDelete: "Confirm delete",
        EnterRouteValue: "Please enter the route value",
        SelectButton: "请选择按钮",
        SelectRoute: "请选择路由",
        CallSequenceConfiguration: "Configuración de secuencia de llamada",
        EnterNumber: "Introduzca un número, número, número...",
        NotPTPAndNextCallTime: "Por favor, no ingrese la hora PTP y la hora de la próxima llamada simultáneamente",
        NextCallTimeTips: "Si ya ha guardado el PTP, no complete este contenido",
        SelectPerson: "Seleccione la persona a la que llamar",
        SelectCallTime: "Seleccione la hora de la llamada",
        SelectWhetherConnect: "Elija si desea conectarse",
    }
};
